import React from 'react';
import { TextRow } from 'react-placeholder/lib/placeholders';
import { colors } from 'commons/src/constants';

const osloGray = colors.osloGray;
export const pageHeaderPlaceholder = (
    <div className="public-page-header">
        <div className="device-header">
            <TextRow className="placeholder__company-info  show-loading-animation" color={osloGray} />

            <div className="addtl-info placeholder">
                <TextRow className="placeholder__location-info  show-loading-animation" color={osloGray} />
                <TextRow className="placeholder__sync-info  show-loading-animation" color={osloGray} />
            </div>
            <div className="addtl-info placeholder">
                <TextRow className="placeholder__serial-number-info  show-loading-animation" color={osloGray} />
                <TextRow className="placeholder__sync-info  show-loading-animation" color={osloGray} />
            </div>
        </div>
    </div>
);

export const tilePlaceholder = (
    <div className="public-tile-wrapper placeholder">
        <div className="public-tile-body">
            <TextRow className="placeholder__tile-info  show-loading-animation" color={osloGray} />
            <TextRow className="placeholder__tile-info  show-loading-animation" color={osloGray} />
            <TextRow className="placeholder__tile-info  show-loading-animation" color={osloGray} />
            <div className="arrow__placeholder">
                <div className="arrow__icon" />
            </div>
        </div>
    </div>
);

export const sensorDataPlaceholder = (
    <div className="public-page-wrapper">
        {tilePlaceholder}
        {tilePlaceholder}
        {tilePlaceholder}
        {tilePlaceholder}
    </div>
);

export const publicDashboardPlaceholder = (
    <div>
        {pageHeaderPlaceholder}
        {sensorDataPlaceholder}
    </div>
);

export default publicDashboardPlaceholder;
